/**
 * User: gedas
 * Date: 10/8/14
 * Time: 9:00 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * AdWords Remarketing Tag
 * https://developers.google.com/adwords-remarketing-tag/
 * exp: //googleads.g.doubleclick.net/pagead/viewthroughconversion/123456789/?value=0&guid=ON&script=0&data.ecomm_prodid=abc123&data.ecomm_pagetype=product
 */
'use strict';

var $ = require('dibs-jquery-shim');
var $body = $('body');
var conversionId = 1009889750;
var imageSrc =
    '//googleads.g.doubleclick.net/pagead/viewthroughconversion/' +
    conversionId +
    '/?value=0&guid=ON&script=0';
var paramsMap;
var pageTypesMap;

// Map parameters to more meaningful names to us
// https://developers.google.com/adwords-remarketing-tag/parameters
paramsMap = {
    productId: 'ecomm_prodid',
    pageType: 'ecomm_pagetype',
    productPrice: 'ecomm_pvalue',
    totalPrice: 'ecomm_totalvalue',
};

// Map page types to more meaningful names to us
pageTypesMap = {
    home: 'home',
    search: 'searchresults',
    browse: 'category',
    pdp: 'product',
    cart: 'cart',
    checkout: 'purchase',
    other: 'other',
};

/**
 * Add pixel/tag image
 *
 * @param {string} src
 */
function addImage(src) {
    $body.append(
        $('<img>', {
            height: '1',
            width: '1',
            style: 'border-style: none;',
            alt: '',
            src: src,
        }).addClass('remarketing-tag')
    );
}

module.exports = {
    /**
     * @param {string} id
     * @param {number} price
     * @param {string} pageType
     */
    product: function(id, price, pageType) {
        var parameters = {};
        pageType = pageTypesMap[pageType] || pageTypesMap.pdp;

        if (!id || !price) {
            return;
        }

        // Can have just alphanumeric value for id
        id = ('' + id).replace(/[^a-z0-9]/gi, '');

        parameters[paramsMap.pageType] = pageType;
        parameters[paramsMap.productId] = id;
        parameters[paramsMap.totalPrice] = price;

        this.create(parameters);
    },

    /**
     * @param {object} parameters
     */
    create: function(parameters) {
        var src = imageSrc;
        parameters = parameters || {};

        // Add params to image src
        $.each(parameters, function(key, value) {
            src += '&data.' + key + '=' + encodeURIComponent(value);
        });

        // Add random param to avoid caching issues
        src += '&' + 'random=' + new Date().getTime();

        addImage(src);
    },
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/commonjs/remarketingTag.js
// module id = 890
// module chunks = 4 5 7 8